











































import { Component } from 'vue-property-decorator';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import RateSourceDetails from '@/components/Products/RateSources/RateSourceDetails.vue'
import RateSourceRates from '@/components/Products/Rates/RateSourceRates.vue'
import EntityType from '@/models/Shared/EntityType';
import History from '@/components/Shared/History.vue';

@Component({ name: 'RateSource', components: { Alert, RateSourceDetails, RateSourceRates, History }, metaInfo: { title: 'Rate Sources' } })
export default class extends SaascadaVue {

    EntityType = EntityType;

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await RateSourceModule.getRateSource(this.$route.params.id);
    }

    get rateSource() {
        return RateSourceModule.rateSource;
    }

    get loading() {
        return RateSourceModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
